import { useEffect, useState } from "react";
import { audio_engine } from "../sound_api/core/AudioEngine";
import {
  updateEffectVolume,
  updateMusicVolume,
} from "../sound_api/effects/Volume";

export const Slider = (props: any) => {
  const [value, setValue] = useState(50);

  useEffect(() => {
    if (props.type === "effect") {
      setValue(Math.round(audio_engine.effect_volume * 100));
    } else {
      setValue(Math.round(audio_engine.music_volume * 100));
    }
  }, [props.volumeUpdater]);

  return (
    <div className="w-full max-w-md mx-auto p-6">
      <div className="relative w-full">
        <div
          className="absolute -top-10"
          style={{
            left: `calc(${value}% + (${8 - value * 0.17}px))`,
            transform: "translateX(-50%)",
          }}
        >
          <div className="bg-yellow-400 text-black text-xs px-2 py-1 rounded-md shadow-md">
            {value}
          </div>
          <div className="w-2 h-2 bg-yellow-400 rotate-45 mx-auto -mt-1" />
        </div>

        {/* Slider */}
        <input
          type="range"
          min={0}
          max={100}
          value={value}
          onChange={(e) => {
            setValue(Number(e.target.value));
            props.type == "effect"
              ? updateEffectVolume(Number(e.target.value) / 100)
              : updateMusicVolume(Number(e.target.value) / 100);
          }}
          className="w-full appearance-none bg-transparent"
          style={{
            background: `linear-gradient(to right, #FF7700 ${value}%, #FF5335 ${value}%)`,
            height: "6px",
            borderRadius: "9999px",
          }}
        />

        <style tsx>{`
          input[type="range"]::-webkit-slider-thumb {
            appearance: none;
            width: 18px;
            height: 18px;
            border-radius: 9999px;
            background: #FFC067;
            cursor: pointer;
            border: 3px solid white;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
          }

          input[type="range"]::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 9999px;
            background: #FFC067;
            cursor: pointer;
            border: 2px solid white;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
          }
        `}</style>
      </div>
    </div>
  );
};
